<template>
  <div class="d-flex align-items-center flex-column">
    <div class="d-flex align-items-center justify-content-center position-relative rounded-circle square-200">
      <b-img v-if="userAvatar" :src="userAvatar" :width="200" :height="200" rounded="circle" alt="Avatar image" />
      <div v-else class="rounded-circle square-200" style="background-color: #616f86;">
        <span class="material-icons default-avatar" style="color: #ffffff">
          person
        </span>
      </div>
      <div class="d-flex justify-content-center cursor-pointer icon-position" variant="primary"
        @click="triggerFileInput">
        <div
        class="d-flex align-items-center justify-content-center rounded-circle icon-size"
          :style="{ 'background-color': '#0052CC', }">
          <span class="material-icons" style="color: #ffffff">
            add_a_photo
          </span>
        </div>
      </div>
      <input type="file" ref="avatarFile" accept="image/*" hidden @change="fileChange">
    </div>

    <b-modal v-model="showAvatarCropModal" @hide="onClose" size="md"
      no-close-on-backdrop centered>
      <template v-slot:modal-header="{ cancel }">
        <h5 class="modal-title">Crop Avatar</h5>
        <CloseButton :onClick="cancel" />
      </template>
      <cropper ref="avatarCropper" :src="value" :stencilProps="{ aspectRatio: 1 / 1 }" />
      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="outline" class="button" @click.prevent="cancel">
          Cancel
        </b-button>
        <b-button variant="primary" class="button" @click.prevent="uploadCroppedAvatar">
          Save
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import CloseButton from '@components/common/CloseButton.vue'

export default {
  name: 'UserAvatar',
  emits: ['uploadCroppedAvatar', 'onAvatarFile', 'resetAvatarInputAfterModalClose'],
  components: {
    Cropper,
    CloseButton
  },
  props: {
    value: {},
    userAvatar: {}
  },
  data () {
    return {
      showAvatarCropModal: false
    }
  },
  methods: {
    onClose () {
      this.$emit('update', '')
      this.$emit('resetAvatarInputAfterModalClose')
    },
    triggerFileInput () {
      this.$refs.avatarFile.value = ''
      this.$refs.avatarFile.click()
    },
    fileChange (e) {
      this.$emit('onAvatarFile', e)
      this.showAvatarCropModal = true
    },
    async uploadCroppedAvatar () {
      const { canvas } = this.$refs.avatarCropper.getResult()
      if (canvas) {
        canvas.toBlob(async (blob) => {
          this.showAvatarCropModal = false
          this.$emit('uploadCroppedAvatar', blob)
        }, 'image/jpeg')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.default-avatar {
  font-size: 180px;
  width: auto;
  height: auto;
}

.square-200 {
  width: 200px;
  height: 200px;
}

.icon-position {
  position: absolute;
  top: 0;
  right: 20px;
}

.icon-size {
  width: 32px;
  height: 32px;
}

</style>
